export default __webpack_public_path__ + "locales/fi/Settings.json?hash=2ccb372b02d1edab3f34c4966c09be04";